import { createContext, useContext } from 'react';

interface ResourceDetailContextType {
  /**
   * Trigger when a detail drawer should open within the component hierarchy.
   */
  onOpenDetailClicked: (data: any, meta: any) => void;
  onOpenProjectDetail: (project: any) => void;
  /**
   * Trigger when a detail drawer should open in a Portal (outside the normal component tree).
   */
  openDetailDrawerInPortal: (data: any, meta: any) => void;
}

export const ResourceDetailContext = createContext<ResourceDetailContextType>({
  onOpenDetailClicked: () => {},
  onOpenProjectDetail: () => {},
  openDetailDrawerInPortal: () => {},
});

export function useResourceDetailHandler() {
  return useContext(ResourceDetailContext);
}
